var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{staticClass:"audio",attrs:{"controls":"","src":_vm.audioUrl}},[_vm._v(" Your browser does not support the "),_c('code',[_vm._v("audio")]),_vm._v(" element. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }